var _rect, _defs, _use, _use2, _use3, _use4, _use5, _use6, _use7, _use8, _use9, _use10, _use11, _use12;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEuFlag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 270 180",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 270,
    height: 180,
    fill: "#003399"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "star",
    points: "0.000,-10.000 2.245,-3.090 9.511,-3.090 3.633,1.180 5.878,8.090 0.000,3.820 -5.878,8.090 -3.633,1.180 -9.511,-3.090 -2.245,-3.090",
    fill: "#ffcc00"
  }))), _use || (_use = /*#__PURE__*/React.createElement("use", {
    href: "#star",
    x: 135,
    y: 30
  })), _use2 || (_use2 = /*#__PURE__*/React.createElement("use", {
    href: "#star",
    x: 165,
    y: 38.038
  })), _use3 || (_use3 = /*#__PURE__*/React.createElement("use", {
    href: "#star",
    x: 186.962,
    y: 60
  })), _use4 || (_use4 = /*#__PURE__*/React.createElement("use", {
    href: "#star",
    x: 195,
    y: 90
  })), _use5 || (_use5 = /*#__PURE__*/React.createElement("use", {
    href: "#star",
    x: 186.962,
    y: 120
  })), _use6 || (_use6 = /*#__PURE__*/React.createElement("use", {
    href: "#star",
    x: 165,
    y: 141.962
  })), _use7 || (_use7 = /*#__PURE__*/React.createElement("use", {
    href: "#star",
    x: 135,
    y: 150
  })), _use8 || (_use8 = /*#__PURE__*/React.createElement("use", {
    href: "#star",
    x: 105,
    y: 141.962
  })), _use9 || (_use9 = /*#__PURE__*/React.createElement("use", {
    href: "#star",
    x: 83.038,
    y: 120
  })), _use10 || (_use10 = /*#__PURE__*/React.createElement("use", {
    href: "#star",
    x: 75,
    y: 90
  })), _use11 || (_use11 = /*#__PURE__*/React.createElement("use", {
    href: "#star",
    x: 83.038,
    y: 60
  })), _use12 || (_use12 = /*#__PURE__*/React.createElement("use", {
    href: "#star",
    x: 105,
    y: 38.038
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEuFlag);
export default __webpack_public_path__ + "static/media/eu-flag.a9f5277cdec7b2b059090d4af78b2370.svg";
export { ForwardRef as ReactComponent };